/**
 * Cart drawer - AJAX remove, quantity, and subscription handlers.
 * Integrates with Shopify Cart API and theme cart:change / cart:refresh events.
 */
(function() {
  'use strict';
  var quantityChangeTimeout = {};
  var QUANTITY_DEBOUNCE_MS = 300;

  function cartDebug(eventName, payload) {
    return;
  }

  function getShopifyRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/');
  }

  function findInComposedPath(e, selector) {
    var path = e.composedPath ? e.composedPath() : (function() {
      var p = []; var t = e.target; while (t) { p.push(t); t = t.parentNode; } return p;
    })();
    for (var i = 0; i < path.length; i++) {
      if (path[i].nodeType === 1 && path[i].matches && path[i].matches(selector)) return path[i];
    }
    return null;
  }

  function getCartDrawerSectionId() {
    const cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer) return null;
    var sectionId = cartDrawer.getAttribute('data-section-id');
    if (sectionId) return sectionId;
    var section = cartDrawer.closest('.shopify-section');
    if (!section || !section.id) return null;
    return section.id.replace('shopify-section-', '');
  }

  function getThemeSectionId() {
    var cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer) return 'no-cart-drawer';
    var section = cartDrawer.closest('.shopify-section');
    if (!section || !section.id) return 'no-section';
    return section.id.replace('shopify-section-', '');
  }

  /** Section ID(s) to request in cart API - one section is enough for drawer HTML, keeps responses fast */
  function getSectionsArray() {
    var sectionId = getCartDrawerSectionId();
    var themeSectionId = getThemeSectionId();
    if (sectionId) return [sectionId];
    if (themeSectionId) return [themeSectionId];
    return ['cart-drawer'];
  }

  /** Fetch with single retry on 429 (rate limit) after 2s - reduces failed requests under high traffic */
  function fetchWithRetry(url, options, retriesLeft) {
    if (retriesLeft == null) retriesLeft = 1;
    return fetch(url, options).then(function(r) {
      if (r.status === 429 && retriesLeft > 0) {
        return new Promise(function(resolve) { setTimeout(resolve, 2000); }).then(function() {
          return fetchWithRetry(url, options, retriesLeft - 1);
        });
      }
      return r;
    });
  }

  function dispatchCartChange(cart, themeSectionId, sectionId, sectionKeys) {
    if (cart.sections[themeSectionId]) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { cart: cart, baseEvent: 'line-item:change' }
      }));
      return true;
    }
    if (sectionId && cart.sections[sectionId]) {
      var patchedCart = Object.assign({}, cart);
      patchedCart.sections = Object.assign({}, patchedCart.sections);
      patchedCart.sections[themeSectionId] = patchedCart.sections[sectionId];
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { cart: patchedCart, baseEvent: 'line-item:change' }
      }));
      return true;
    }
    if (sectionKeys.length > 0) {
      var firstKey = sectionKeys[0];
      var patchedCart = Object.assign({}, cart);
      patchedCart.sections = Object.assign({}, patchedCart.sections);
      patchedCart.sections[themeSectionId] = cart.sections[firstKey];
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { cart: patchedCart, baseEvent: 'line-item:change' }
      }));
      return true;
    }
    return false;
  }

  var checkoutLockCount = 0;
  function setCheckoutUpdating(updating) {
    var btn = document.querySelector('#cart-drawer .cart-drawer__checkout-button');
    var form = document.getElementById('cart-drawer-form');
    if (!btn && !form) return;
    if (updating) {
      checkoutLockCount++;
      cartDebug('checkout:lock', { lockCount: checkoutLockCount });
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.classList.add('cart-drawer__checkout-button--updating');
      }
      if (form) form.style.pointerEvents = 'none';
    } else {
      checkoutLockCount = Math.max(0, checkoutLockCount - 1);
      cartDebug('checkout:unlock', { lockCount: checkoutLockCount });
      if (checkoutLockCount === 0) {
        if (btn) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.classList.remove('cart-drawer__checkout-button--updating');
        }
        if (form) form.style.pointerEvents = '';
      }
    }
  }

  function setupCartDrawerListeners() {
    var cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer) return false;
    if (cartDrawer._cartListenersAttached) return true;
    cartDrawer._cartListenersAttached = true;

    cartDrawer.addEventListener('click', function(e) {
      var sub = findInComposedPath(e, '.cart-drawer__subscribe-button');
      var freqSelect = findInComposedPath(e, '.cart-drawer__frequency-select');
      var onceBtn = findInComposedPath(e, '.cart-drawer__toggle-onetime');
      var subArea = findInComposedPath(e, '.cart-drawer__item-subscription');
      if (sub) {
        e.preventDefault();
        e.stopPropagation();
        handleSubscribeClick(sub);
      } else if (onceBtn) {
        e.preventDefault();
        e.stopPropagation();
        handleToggleOneTime(onceBtn);
      } else if (freqSelect) {
        return;
      } else if (subArea) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
    return true;
  }

  function subscribeRiskFreeButtonLabel(subscribeBtn) {
    var p = subscribeBtn && subscribeBtn.getAttribute('data-subscribe-discount-percent');
    var pct = p !== null && p !== '' ? parseInt(p, 10) : 10;
    if (isNaN(pct) || pct < 0) pct = 10;
    return 'Subscribe Risk-Free - ' + pct + '% Off + Rewards';
  }

  function setSubscribeButtonBusyState(subscribeBtn, busy) {
    var primary = subscribeBtn.querySelector && subscribeBtn.querySelector('.cart-drawer__subscribe-button__primary');
    var subEl = subscribeBtn.querySelector && subscribeBtn.querySelector('.cart-drawer__subscribe-button__sub');
    if (primary) {
      if (busy) {
        primary.textContent = 'Updating...';
        if (subEl) subEl.setAttribute('hidden', 'hidden');
      } else {
        primary.textContent = 'Subscribe';
        if (subEl) {
          subEl.removeAttribute('hidden');
          var p = subscribeBtn.getAttribute('data-subscribe-discount-percent');
          var pct = p !== null && p !== '' ? parseInt(p, 10) : 10;
          if (isNaN(pct) || pct < 0) pct = 10;
          subEl.textContent = pct + '% off + Rewards';
        }
      }
    } else if (busy) {
      subscribeBtn.textContent = 'Updating...';
    } else {
      subscribeBtn.textContent = subscribeRiskFreeButtonLabel(subscribeBtn);
    }
  }

  function handleToggleOneTime(onceBtn) {
    var lineItem = onceBtn.closest && onceBtn.closest('.cart-drawer__item');
    if (!lineItem) return;
    var sel = lineItem.querySelector('.cart-drawer__frequency-select');
    if (!sel || sel.value === 'onetime') return;
    sel.value = 'onetime';
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  }

  async function handleSubscribeClick(subscribeBtn) {
    if (subscribeBtn.getAttribute('aria-busy') === 'true') return;
    var sellingPlanId = subscribeBtn.getAttribute('data-selling-plan-id');
    if (!sellingPlanId) return;
    var lineKey = subscribeBtn.getAttribute('data-line-key');
    var quantity = parseInt(subscribeBtn.getAttribute('data-quantity'), 10) || 1;
    if (!lineKey) return;
    cartDebug('subscribe:click', { lineKey: lineKey, sellingPlanId: sellingPlanId, quantity: quantity });
    var sections = getSectionsArray();
    var root = getShopifyRoot();
    var themeSectionId = getThemeSectionId();
    var sectionId = getCartDrawerSectionId();
    subscribeBtn.disabled = true;
    subscribeBtn.setAttribute('aria-busy', 'true');
    setSubscribeButtonBusyState(subscribeBtn, true);
    setCheckoutUpdating(true);
    try {
      var res = await fetchWithRetry(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: quantity, selling_plan: parseInt(sellingPlanId, 10), sections: sections })
      });
      var text = await res.text();
      cartDebug('subscribe:cart/change:response', { ok: res.ok, status: res.status, bodyPreview: (text || '').substring(0, 200) });
      var cart;
      try { cart = JSON.parse(text); } catch (err) {
        setCheckoutUpdating(false);
        subscribeBtn.disabled = false;
        subscribeBtn.removeAttribute('aria-busy');
        setSubscribeButtonBusyState(subscribeBtn, false);
        return;
      }
      var sectionKeys = cart && cart.sections ? Object.keys(cart.sections) : [];
      if (res.ok && cart && cart.sections) {
        cartDebug('subscribe:complete');
        dispatchCartChange(cart, themeSectionId, sectionId, sectionKeys);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function() { setCheckoutUpdating(false); }, 2000);
      } else {
        cartDebug('subscribe:failed', { ok: res.ok, hasSections: !!(cart && cart.sections) });
        setCheckoutUpdating(false);
      }
      subscribeBtn.disabled = false;
      subscribeBtn.removeAttribute('aria-busy');
      setSubscribeButtonBusyState(subscribeBtn, false);
    } catch (err) {
      cartDebug('subscribe:error', { message: err && err.message ? err.message : String(err) });
      setCheckoutUpdating(false);
      subscribeBtn.disabled = false;
      subscribeBtn.removeAttribute('aria-busy');
      setSubscribeButtonBusyState(subscribeBtn, false);
    }
  }

  function initWhenReady() {
    if (setupCartDrawerListeners()) return;
    var attempts = 0;
    var id = setInterval(function() {
      attempts++;
      if (setupCartDrawerListeners() || attempts > 100) clearInterval(id);
    }, 100);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenReady);
  } else {
    initWhenReady();
  }

  document.addEventListener('click', function(e) {
    var cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.show !== 'function') return;
    var cartType = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType) || '';
    if (cartType === 'page') return;
    var path = window.location.pathname || '';
    if (path.replace(/\/$/, '').endsWith('/cart')) return;
    var el = e.target.closest ? e.target.closest('a[href*="/cart"], a[href*="cart"]') : null;
    if (!el || el.getAttribute('aria-controls') === 'cart-drawer') return;
    var href = (el.getAttribute('href') || '').toLowerCase();
    if (href.indexOf('checkout') >= 0) return;
    if (href.indexOf('/cart') >= 0 || href === '/cart' || href.endsWith('/cart')) {
      e.preventDefault();
      e.stopPropagation();
      cartDrawer.show();
    }
  }, true);

  document.addEventListener('click', function(e) {
    var sub = findInComposedPath(e, '.cart-drawer__subscribe-button');
    if (sub) {
      e.preventDefault();
      e.stopPropagation();
      handleSubscribeClick(sub);
    }
  }, true);

  document.addEventListener('change', function(e) {
    var target = e.target;
    var freqSelect = target.matches && target.matches('.cart-drawer__frequency-select') ? target : null;
    if (freqSelect) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      var lineKey = freqSelect.getAttribute('data-line-key');
      var quantity = parseInt(freqSelect.getAttribute('data-quantity'), 10) || 1;
      var val = freqSelect.value;
      if (!lineKey) return;
      var sellingPlan = val === 'onetime' ? null : parseInt(val, 10);
      cartDebug('frequency:change', { lineKey: lineKey, rawValue: val, sellingPlan: sellingPlan, quantity: quantity });
      if (val !== 'onetime' && isNaN(sellingPlan)) return;
      freqSelect.disabled = true;
      setCheckoutUpdating(true);
      var lineItem = freqSelect.closest('.cart-drawer__item');
      if (lineItem) { lineItem.style.opacity = '0.6'; lineItem.style.pointerEvents = 'none'; }
      var sections = getSectionsArray();
      var root = getShopifyRoot();
      fetchWithRetry(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: quantity, selling_plan: sellingPlan, sections: sections })
      }).then(function(r) { return r.text().then(function(t) { return { ok: r.ok, text: t, status: r.status }; }); }).then(function(res) {
        cartDebug('frequency:cart/change:response', { ok: res.ok, status: res.status, bodyPreview: (res.text || '').substring(0, 200) });
        var cart;
        try { cart = JSON.parse(res.text); } catch (err) {
          setCheckoutUpdating(false);
          freqSelect.disabled = false;
          if (lineItem) { lineItem.style.opacity = ''; lineItem.style.pointerEvents = ''; }
          return;
        }
        if (res.ok && cart && cart.sections) {
          var themeSectionId = getThemeSectionId();
          var sectionId = getCartDrawerSectionId();
          var sectionKeys = Object.keys(cart.sections);
          cartDebug('frequency:complete');
          dispatchCartChange(cart, themeSectionId, sectionId, sectionKeys);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setCheckoutUpdating(false);
          freqSelect.disabled = false;
          if (lineItem) { lineItem.style.opacity = ''; lineItem.style.pointerEvents = ''; }
        } else {
          setCheckoutUpdating(false);
          freqSelect.disabled = false;
          if (lineItem) { lineItem.style.opacity = ''; lineItem.style.pointerEvents = ''; }
        }
      }).catch(function() {
        cartDebug('frequency:error');
        setCheckoutUpdating(false);
        freqSelect.disabled = false;
        if (lineItem) { lineItem.style.opacity = ''; lineItem.style.pointerEvents = ''; }
      });
      return;
    }
    var input = target;
    if (!input.matches || !input.matches('.cart-drawer__quantity-input, .quantity-input')) return;
    var lineKey = input.getAttribute('data-line-key');
    if (!lineKey) return;
    var cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer || !cartDrawer.contains(input)) return;

    var targetQty = parseInt(input.value, 10);
    if (isNaN(targetQty) || targetQty < 1) {
      input.value = input.getAttribute('min') || 1;
      return;
    }
    var max = input.getAttribute('max');
    if (max && targetQty > parseInt(max, 10)) {
      input.value = max;
      targetQty = parseInt(max, 10);
    }

    var lineItem = input.closest('.cart-drawer__item');
    if (lineItem) {
      lineItem.style.opacity = '0.6';
      lineItem.style.pointerEvents = 'none';
    }
    setCheckoutUpdating(true);
    clearTimeout(quantityChangeTimeout[lineKey]);
    quantityChangeTimeout[lineKey] = setTimeout(function() {
      delete quantityChangeTimeout[lineKey];
      setTimeout(function() {
        setCheckoutUpdating(false);
      }, 2000);
    }, QUANTITY_DEBOUNCE_MS);
  }, true);

  document.addEventListener('line-item:error', function(e) {
    var lineItem = e.target && e.target.closest ? e.target.closest('.cart-drawer__item') : null;
    if (lineItem) {
      lineItem.style.opacity = '';
      lineItem.style.pointerEvents = '';
    }
    setCheckoutUpdating(false);
  });

  document.addEventListener('click', async function(e) {
    const btn = findInComposedPath(e, '.cart-drawer__item-remove[data-line-key]') || e.target.closest('.cart-drawer__item-remove[data-line-key]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const lineKey = btn.getAttribute('data-line-key');
    if (!lineKey) return;
    cartDebug('remove:click', { lineKey: lineKey });

    const sectionId = getCartDrawerSectionId();
    const themeSectionId = getThemeSectionId();
    var sections = getSectionsArray();
    var root = getShopifyRoot();
    const url = root + 'cart/change.js';

    var lineItem = btn.closest('.cart-drawer__item');
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    setCheckoutUpdating(true);

    var loader = document.createElement('div');
    loader.className = 'cart-drawer__remove-loader';
    loader.innerHTML = '<span class="cart-drawer__remove-loader-spinner"></span>';
    if (lineItem) {
      lineItem.style.position = 'relative';
      lineItem.style.opacity = '0.6';
      lineItem.style.pointerEvents = 'none';
      lineItem.appendChild(loader);
    }

    try {
      const requestBody = { id: lineKey, quantity: 0, sections: sections };
      const response = await fetchWithRetry(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestBody)
      });

      var text = await response.text();
      cartDebug('remove:cart/change:response', { ok: response.ok, status: response.status, bodyPreview: (text || '').substring(0, 200) });
      var cart;
      try {
        cart = JSON.parse(text);
      } catch (parseErr) {
        setCheckoutUpdating(false);
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        if (lineItem) {
          lineItem.style.opacity = '';
          lineItem.style.pointerEvents = '';
          var l = lineItem.querySelector('.cart-drawer__remove-loader');
          if (l) l.remove();
        }
        return;
      }
      var sectionKeys = cart && cart.sections ? Object.keys(cart.sections) : [];

      if (response.ok && cart) {
        cartDebug('remove:complete');
        if (cart.sections) dispatchCartChange(cart, themeSectionId, sectionId, sectionKeys);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function() {
          setCheckoutUpdating(false);
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
          if (lineItem && lineItem.parentNode) {
            lineItem.style.opacity = '';
            lineItem.style.pointerEvents = '';
            var l = lineItem.querySelector('.cart-drawer__remove-loader');
            if (l) l.remove();
          }
        }, 2000);
      } else {
        cartDebug('remove:failed', { ok: response.ok, status: response.status });
        setCheckoutUpdating(false);
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        if (lineItem) {
          lineItem.style.opacity = '';
          lineItem.style.pointerEvents = '';
          if (loader.parentNode) loader.remove();
        }
      }
    } catch (err) {
      cartDebug('remove:error', { message: err && err.message ? err.message : String(err) });
      setCheckoutUpdating(false);
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
      if (lineItem) {
        lineItem.style.opacity = '';
        lineItem.style.pointerEvents = '';
        loader.remove();
      }
    }
  });

  document.addEventListener('cart:change', function(e) {
    var cart = e.detail && e.detail.cart;
    if (!cart || !cart.items) {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return;
    }
    var themeSectionId = getThemeSectionId();
    var hasSections = !!(cart.sections && cart.sections[themeSectionId]);
    cartDebug('event:cart:change', { itemCount: cart.item_count, hasSections: hasSections });
    setTimeout(function() {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }, 0);
  });

  var cartRefreshTimeout;
  var CART_REFRESH_DEBOUNCE_MS = 50;
  document.addEventListener('cart:refresh', function() {
    clearTimeout(cartRefreshTimeout);
    cartRefreshTimeout = setTimeout(function() {
      cartDebug('event:cart:refresh');
      setTimeout(function() {
        setCheckoutUpdating(false);
      }, 2000);
    }, CART_REFRESH_DEBOUNCE_MS);
  });

})();
